import { useState, useEffect } from "react";
import React from 'react';
import {
  Button,
  Card,
  Table,
  Container,
  Row,
  Form,
  Input,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../../assets/css/custom.css";
import Header from "../../../components/Headers/Header.js";
import 'assets/css/themecustom-style.css';
import { ToastContainer, toast } from 'react-toastify';
import { usermanageService } from "../../../services/usermanageService";

const unitOptions = [
  { value: '%', label: 'Percentage' },
  { value: 'int', label: 'Integer' },
  { value: 'char', label: 'Character' },
];

const KroTypes = (props) => {
  const [trans_data, settransData] = useState([]);
  const [state, setState] = useState({});
  const [disablestate, setdisablestate] = useState(false);
  const [newbox, setNewBox] = useState(0);
  const [defaultkey, setdefaultKey] = useState(0);

  useEffect(() => {
    showKroTypes();
  }, []);

  function showKroTypes() {
    usermanageService.showKroTypes().then((response) => {
      if (response.status === 200) {
        settransData(response.data);
        setState(response.data);
        setdefaultKey(response.data.length + 1);
        setNewBox(response.data.length + 1);
      } else {
        toast.error('Something went wrong!');
      }
    });
  }

  function inputhandler(e, index) {
    let temp_st = { ...state };
    let temp_ele = { ...temp_st[index] };
    temp_ele[e.target.name] = e.target.value;
    temp_st[index] = temp_ele;
    setState(temp_st);
  }

  function addsopform(e) {
    e.preventDefault();
    setdisablestate(true);
    usermanageService.saveKroTypes(state).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message);
        showKroTypes();
      } else {
        toast.error('Something went wrong!');
      }
      setdisablestate(false);
    });
  }

  const addNewbox = () => {
    setNewBox(newbox + 1);
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-12">
          <Card className="shadow" style={{ width: "100%" }}>
            <Form role="form" id="kro-types-form" onSubmit={addsopform}>
              <Table className="align-items-center table-flush" responsive>
                <thead>
                  <tr style={{ border: "1px solid #000" }}>
                    <th style={{ border: "1px solid #000" }}>Sr.No.</th>
                    <th style={{ border: "1px solid #000" }} className="whitespace">Type</th>
                    <th style={{ border: "1px solid #000" }} className="whitespace">Unit</th>
                    <th style={{ border: "1px solid #000" }} className="whitespace">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {trans_data && trans_data.length && trans_data != null ? (
                    trans_data.map((item, i) => (
                      <tr key={item.id} className="whitespace" style={{ border: "1px solid #000" }}>
                        <td className="whitespace" style={{ border: "1px solid #000" }}>{i + 1}</td>
                        <td className="whitespace" style={{ border: "1px solid #000" }}>
                          <Input
                            bsSize="sm"
                            name="type"
                            placeholder="Type"
                            type="text"
                            defaultValue={item.type}
                            onChange={(e) => inputhandler(e, i)}
                          />
                        </td>
                        <td className="whitespace" style={{ border: "1px solid #000" }}>
                          <select
                            className="form-control"
                            name="unit"
                            defaultValue={item.unit}
                            onChange={(e) => inputhandler(e, i)}
                          >
                            <option value="">Select Unit</option>
                            {unitOptions.map((unit) => (
                              <option key={unit.value} value={unit.value}>{unit.label}</option>
                            ))}
                          </select>
                        </td>
                        <td className="whitespace" style={{ border: "1px solid #000" }}>
                          {item.status ? 'Active' : 'Archived'}
                        </td>
                      </tr>
                    ))
                  ) : null}
                  {(() => {
                    const arr1 = [];
                    for (let key = defaultkey; key < newbox; key++) {
                      arr1.push(
                        <tr key={key} className="whitespace" style={{ border: "1px solid #000" }}>
                          <td style={{ border: "1px solid #000" }}>{key}</td>
                          <td style={{ border: "1px solid #000" }}>
                            <Input
                              bsSize="sm"
                              name="type"
                              placeholder="Type"
                              type="text"
                              onChange={(e) => inputhandler(e, key)}
                            />
                          </td>
                          <td className="whitespace" style={{ border: "1px solid #000" }}>
                            <select
                              className="form-control"
                              name="unit"
                              defaultValue=""
                              onChange={(e) => inputhandler(e, key)}
                            >
                              <option value="">Select Unit</option>
                              {unitOptions.map((unit) => (
                                <option key={unit.value} value={unit.value}>{unit.label}</option>
                              ))}
                            </select>
                          </td>
                          <td className="whitespace" style={{ border: "1px solid #000" }}></td>
                        </tr>
                      );
                    }
                    return arr1;
                  })()}
                </tbody>
              </Table>
            </Form>
            <br></br>
            <div className="d-flex">
              <Button color="secondary" className="col-xl-2" style={{ flex: "0 0 4.66667%" }} type="button" onClick={addNewbox}>
                <i className="fa fa-plus"></i> Add Row
              </Button>
              <Button color="primary" className="col-xl-2" style={{ flex: "0 0 4.66667%" }} type="button" onClick={addsopform} disabled={disablestate}>
                {disablestate ? 'Sending...' : 'Save'}
              </Button>
            </div>
          </Card>
        </Row>
      </Container>
    </>
  );
};

export default KroTypes;
